import home from './src/home.vue'
import WarnConfigView from './src/WarnConfig/WarnConfigView.vue' //报警配置列表
import WarnConfigInfo from './src/WarnConfig/WarnConfigInfo.vue' //报警配置详情
import WarnRecordView from './src/WarnRecord/WarnRecordView.vue' //报警记录列表
import EquipmentWarnRecordView from './src/WarnRecord/EquipmentWarnRecordView.vue' //设备报警记录列表

let views = {
    home,
    WarnConfigView,
    WarnConfigInfo,
    WarnRecordView,
    EquipmentWarnRecordView
};

export default views;